interface StepIndicatorProps {
  currentStep: number
  totalSteps: number
}

const StepIndicator = ({ currentStep }: StepIndicatorProps) => {
  const steps = [
    { number: 1, label: '基本情報' },
    { number: 2, label: '詳細情報' },
    { number: 3, label: 'メモ' },
    { number: 4, label: '確認・同意' },
  ]

  return (
    <div className="flex items-center gap-2">
      {steps.map((step, index) => (
        <div key={step.number} className="flex items-center">
          {/* ステップ円（コンパクト版） */}
          <div
            className={`
              w-8 h-8 rounded-full flex items-center justify-center
              font-light text-sm transition-all duration-300
              ${
                currentStep === step.number
                  ? 'bg-white text-primary ring-2 ring-white'
                  : currentStep > step.number
                  ? 'bg-white/30 text-white'
                  : 'bg-white/10 text-white/50'
              }
            `}
          >
            {currentStep > step.number ? '✓' : step.number}
          </div>

          {/* 接続線（コンパクト版） */}
          {index < steps.length - 1 && (
            <div
              className={`
                w-6 h-0.5 mx-1 transition-all duration-300
                ${currentStep > step.number ? 'bg-white/50' : 'bg-white/20'}
              `}
            />
          )}
        </div>
      ))}
    </div>
  )
}

export default StepIndicator
